import { handleAction, handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { journal as journalActions } from 'shared/actions/globals';
import { GLOBALS, JOURNAL } from '../constants/actionTypes';

const createNoopReducer = defaultValue => state => state || defaultValue;

const initialState = {
  location: null,
  locale: null,
  ratio: null,
  stateDataLayer: [],
  banner: {
    slot_1: false,
    bannerNotErr: {},
  },
  fingerprint: '',
  redirectUrl: '',
  targeting: {},
  isBot: false,
  paymentModalId: '',
  dealerSlug: null,
  journal: {
    rubrics: null,
    news: null,
    videoTopics: [],
    videoOrderBy: {
      id: 'new',
      title: 'Самые новые',
      slug: 'new',
    },
    videoFilters: {
      make: null,
      model: null,
      generation: null,
      topic: null,
    },
    selVideoParams: null,
    selVideoData: null,
  },
  seoSearchUrlResponse: null,
  seoText: null,
  promoteInSocial: 0,
  insurance: {
    regions: null,
    filters: null,
    selectedValues: {},
    selectedOffer: null,
    offersData: null,
    orderWithHash: null,
    orders: [],
    isNumberBlock: false,
    editOrder: null,
    fillData: null,
    makes: [],
    isShowConfirmModal: false,
  },
  isApprovePub: false,
};

function insurance(state = initialState.insurance, action) {
  switch (action.type) {
    case GLOBALS.SET_SELECTED_OFFER:
      return {
        ...state,
        selectedOffer: action.payload,
      };
    case GLOBALS.SET_INSURANCE_MAKES:
      return {
        ...state,
        makes: action.payload,
      };
    case GLOBALS.SET_FILL_DATA:
      return {
        ...state,
        fillData: action.payload,
      };
    case GLOBALS.SET_ORDER_WITH_HASH:
      return {
        ...state,
        orderWithHash: action.payload,
      };
    case GLOBALS.SET_SELECTED_VALUES:
      return {
        ...state,
        selectedValues: action.payload,
      };
    case GLOBALS.SET_OFFERS_DATA:
      return {
        ...state,
        offersData: action.payload,
      };
    case GLOBALS.SET_INSURANCE_REGIONS:
      return {
        ...state,
        regions: action.payload,
      };
    case GLOBALS.SET_INSURANCE_ORDERS:
      return {
        ...state,
        orders: action.payload,
      };
    case GLOBALS.SET_IS_NUMBER_BLOCK:
      return {
        ...state,
        isNumberBlock: action.payload,
      };
    case GLOBALS.SET_SHOW_CONFIRM_MODAL:
      return {
        ...state,
        isShowConfirmModal: action.payload,
      };
    case GLOBALS.SET_ORDER_FOR_EDIT:
      return {
        ...state,
        editOrder: action.payload,
      };
    case GLOBALS.SET_INSURANCE_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    default:
      return state;
  }
}

const journal = handleActions(
  {
    [journalActions.setRubrics]: (state, action) => ({ ...state, rubrics: action.payload }),
    [JOURNAL.SET_NEWS]: (state, action) => ({ ...state, news: action.payload }),
    [JOURNAL.SET_VIDEO_TOPICS]: (state, action) => ({ ...state, videoTopics: action.payload }),
    [JOURNAL.SET_VIDEO_HEAD_FILTER]: (state, action) => ({
      ...state,
      videoOrderBy: action.payload,
    }),
    [JOURNAL.SET_VIDEO_FILTERS]: (state, action) => ({ ...state, videoFilters: action.payload }),
    [JOURNAL.SET_SELECTED_VIDEO_PARAMS]: (state, action) => ({
      ...state,
      selVideoParams: action.payload,
    }),
    [JOURNAL.SET_SELECTED_VIDEO_DATA]: (state, action) => ({
      ...state,
      selVideoData: action.payload,
    }),
  },
  initialState.journal,
);

const promoteInSocial = handleAction(
  GLOBALS.PROMOTE_IN_SOCIAL_SET,
  (state, action) => action.payload,
  initialState.promoteInSocial,
);
const fingerprint = handleAction(
  GLOBALS.FINGERPRINT_SET,
  (state, action) => action.payload,
  initialState.fingerprint,
);
const redirectUrl = handleAction(
  GLOBALS.SET_REDIRECT_URL,
  (state, action) => action.payload,
  initialState.redirectUrl,
);
const location = handleAction(
  GLOBALS.LOCATION_SET,
  (state, action) => action.payload,
  initialState.location,
);
const ratio = handleAction(
  GLOBALS.RATIO_SET,
  (state, action) => action.payload,
  initialState.ratio,
);
const targeting = handleAction(
  GLOBALS.TARGETING_ARGUMENTS_SET,
  (state, action) => ({ ...state, targetingSlot: action.payload }),
  initialState.targeting,
);
const seoSearchUrlResponse = handleAction(
  GLOBALS.SEO_SEARCH_URLS,
  (state, action) => action.payload,
  initialState.targeting,
);
const paymentModalId = handleAction(
  GLOBALS.PAYMENT_SET_MODAL,
  (state, action) => action.payload,
  initialState.paymentModalId,
);
const seoText = handleAction(
  GLOBALS.SEO_TEXT_SET,
  (state, action) => ({ ...action.payload }),
  initialState.seoSearchUrlResponse,
);
const stateDataLayer = handleAction(
  GLOBALS.DATA_LAYER_SET,
  (state, action) => {
    const payload = { ...action.payload };
    if (typeof window === 'object' && window.dataLayer && Array.isArray(window.dataLayer)) {
      if (payload && 'url' in payload) {
        delete payload.url;
      }
      window.dataLayer.push(payload);
    }
    return { ...state, ...payload };
  },
  initialState.stateDataLayer,
);
const banner = handleActions(
  {
    [GLOBALS.BANNER_SHOW]: state => ({ ...state, slot_1: true }),
    [GLOBALS.BANNER_UPDATE]: (state, action) => {
      const { id, addComponent, deleteComponent } = action.payload;
      const localState = { ...state };
      if (deleteComponent) {
        localState.bannerNotErr[id] = false;
      }
      if (addComponent) {
        localState.bannerNotErr[id] = true;
      }
      return localState;
    },

    [GLOBALS.BANNER_HIDE]: state => ({ ...state, slot_1: false }),
  },
  initialState.banner,
);

const dealerSlug = handleAction(
  GLOBALS.DEALER_SLUG_SET,
  (state, action) => action.payload,
  initialState.dealerSlug,
);

const isApprovePub = handleAction(
  GLOBALS.SET_IS_APPROVE_PUB,
  (state, action) => action.payload,
  initialState.isApprovePub,
);

export default combineReducers({
  location,
  locale: createNoopReducer(initialState.locale),
  targeting,
  seoSearchUrlResponse,
  stateDataLayer,
  ratio,
  banner,
  fingerprint,
  redirectUrl,
  isBot: createNoopReducer(initialState.isBot),
  journal,
  seoText,
  paymentModalId,
  promoteInSocial,
  dealerSlug,
  insurance,
  isApprovePub,
});



// WEBPACK FOOTER //
// ./src/shared/reducers/globals.js